/* 
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

/**
 * Contient les textes utilisés dans le logiciel en langue anglaise
 * @type mtg32.texte_en
 */
const texte_en  = {
  step:"pas",
  var1:"New value for variable ",
  var2:"Enter a value between ",
  et:" and ",
  //Chaînes servant suivant la langue à reconstruire les formules mathématiques


  abs:"abs",
  intgr:"int",
  sqrt:"sqrt",
  rac:"sqrt",
  sin:"sin",
  cos:"cos",
  tan:"tan",
  ln:"log",
  exp:"exp",
  arctan:"atan",
  arccos:"acos",
  arcsin:"asin",
  ch:"cosh",
  sh:"sinh",
  th:"tanh",
  argch:"acosh",
  argsh:"asinh",
  argth:"atanh",
  rand:"rand",
  conj:"conj",
  arg:"angle",
  re:"re",
  im:"im",

  maxi:"max",
  mini:"min",
  gcd:"gcd",
  lcm:"lcm",
  ncr:"nCr",
  npr:"nPr",
  mod:"mod",
  si:"if",
  integrale:"integral",
  fact:"fact",
  somme:"sum",
  produit:"prod",
  left:"left",
  right:"right",

};

module.exports = texte_en



// WEBPACK FOOTER //
// ./src/textes/textes_en.js